<template>
  <div class="profile content-width">

    <el-alert
      style="margin-bottom: 1.5em;"
      title="This section shows your account information."
      type="info"
      show-icon>
      <div>
        <small>Please <SupportButton class="link">contact us</SupportButton> if you spot any error.</small>
      </div>
    </el-alert>

    <FilmmakerDetailsForm
      v-model="account"
      :editable="false"
      :showReferral="false"
    />
  </div>
</template>

<script>
import SupportButton from '@/components/Utilities/SupportButton';
import FilmmakerDetailsForm from './FilmmakerDetailsForm';

export default {
  components: {
    FilmmakerDetailsForm,
    SupportButton,
  },
  computed: {
    account() {
      return this.$store.state.account.blob.film_maker_details;
    },
  },
  data() {
    return {
      editable: false,
    };
  },
};
</script>

<style lang="scss">
.profile {
  .el-input.is-disabled input {
    background-color: white;
    color: black;
    cursor: default;
  }

  .el-form-item__label::before {
    visibility: hidden;
  }
}

.link {
  text-decoration: underline;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Profile/index.vue